import { useMemo, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { toast } from "sonner";
import { useRequireRole } from "@/lib/use-require-role";
import { PageHeader } from "@/components/page-header";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { mockUsers } from "@/lib/mock-auth";
import { organizations } from "@/mocks/saas-data";

export const Route = createFileRoute("/admin/users")({
  ssr: false,
  head: () => ({ meta: [{ title: "Admin — Users" }] }),
  component: Page,
});

function Page() {
  const user = useRequireRole(["superadmin"]);
  const [q, setQ] = useState("");
  const filtered = useMemo(
    () => mockUsers.filter((u) => `${u.name} ${u.email} ${u.role}`.toLowerCase().includes(q.toLowerCase())),
    [q],
  );
  if (!user) return null;

  return (
    <div className="mx-auto max-w-6xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader title="Users" description="All accounts across every organization." />
      <Input placeholder="Search by name, email or role…" value={q} onChange={(e) => setQ(e.target.value)} className="mb-4 max-w-sm" />
      <div className="overflow-hidden rounded-xl bg-card ring-1 ring-border">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-border bg-surface-muted/50">
            <tr className="text-[11px] uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3 font-medium">User</th>
              <th className="px-4 py-3 font-medium">Role</th>
              <th className="px-4 py-3 font-medium">Organization</th>
              <th className="px-4 py-3 text-right font-medium">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {filtered.map((u) => {
              const org = organizations.find((o) => o.id === u.orgId);
              return (
                <tr key={u.id}>
                  <td className="px-4 py-3">
                    <p className="font-medium">{u.name}</p>
                    <p className="font-mono text-[11px] text-muted-foreground">{u.email}</p>
                  </td>
                  <td className="px-4 py-3 font-mono text-[10px] uppercase">{u.role}</td>
                  <td className="px-4 py-3 text-muted-foreground">{org?.name ?? "—"}</td>
                  <td className="px-4 py-3 text-right">
                    <Button size="sm" variant="outline" onClick={() => toast.info(`Reset email sent to ${u.email}`)}>Reset password</Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
